export { MorphemeInfoPanelDictionaryRankSection } from "#morpheme-info-panel-dictionary-rank-section";
